export default __webpack_public_path__ + "static/dwolla-a836b78178c053f48ad968b41765dd54.png";